var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components" }, [
        _c("div", { staticClass: "container pd-x-0 pd-lg-x-10 pd-xl-x-0 bs" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-none d-md-block" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                    on: {
                      click: function($event) {
                        return _vm.saveFilter()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "wd-10 mg-r-5",
                      attrs: { "data-feather": "folder" }
                    }),
                    _vm._v("Save")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                    on: {
                      click: function($event) {
                        return _vm.goList()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "wd-10 mg-r-5",
                      attrs: { "data-feather": "file" }
                    }),
                    _vm._v("list")
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-100 bs2" }, [
            _c("div", { staticClass: "card ht-100p" }, [
              _c(
                "form",
                {
                  staticClass:
                    "card-body list-group list-group-flush tx-13list-group list-group-flush tx-13",
                  attrs: {
                    action: "form-validation.html",
                    "data-parsley-validate": ""
                  }
                },
                [
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.companyName,
                            expression: "companyName",
                            modifiers: { trim: true }
                          }
                        ],
                        ref: "companyName",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "companyName",
                          placeholder: "업체명"
                        },
                        domProps: { value: _vm.companyName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.companyName = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.companyCode,
                            expression: "companyCode",
                            modifiers: { trim: true }
                          }
                        ],
                        ref: "companyCode",
                        staticClass: "form-control",
                        staticStyle: { "text-transform": "uppercase" },
                        attrs: {
                          type: "text",
                          id: "companyCode",
                          placeholder: "업체코드",
                          maxlength: "3"
                        },
                        domProps: { value: _vm.companyCode },
                        on: {
                          keyup: function($event) {
                            return _vm.engOnlyEvent()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.companyCode = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "input3" } }, [
                        _vm._v("담당자")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.manager,
                            expression: "manager",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "manager",
                          placeholder: "담당자"
                        },
                        domProps: { value: _vm.manager },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.manager = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-md-6" }, [
                      _c("label", { attrs: { for: "input4" } }, [
                        _vm._v("연락처")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.telNo,
                            expression: "telNo",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "telNo",
                          placeholder: "연락처"
                        },
                        domProps: { value: _vm.telNo },
                        on: {
                          keyup: function($event) {
                            return _vm.numberCheckEvent()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.telNo = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "input5" } }, [_vm._v("주소")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.address,
                          expression: "address",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "address",
                        placeholder: "주소"
                      },
                      domProps: { value: _vm.address },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.address = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  this.saveMode == "update"
                    ? _c("div", { staticClass: "modeRedering" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "label-title" }, [
                            _vm._v("Status")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-2 custom-control custom-radio mb-1"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.usedCode,
                                      expression: "usedCode",
                                      modifiers: { trim: true }
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "radio",
                                    name: "usedcode",
                                    id: "usedcode1",
                                    value: "1"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.usedCode, "1")
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.usedCode = "1"
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "usedcode1" }
                                  },
                                  [_vm._v("Used")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-2 custom-control custom-radio mb-1"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.usedCode,
                                      expression: "usedCode",
                                      modifiers: { trim: true }
                                    }
                                  ],
                                  staticClass:
                                    "custom-control-input form-check-input",
                                  attrs: {
                                    type: "radio",
                                    name: "usedcode",
                                    id: "usedcode0",
                                    value: "0"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.usedCode, "0")
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.usedCode = "0"
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "usedcode0" }
                                  },
                                  [_vm._v("Unused")]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "sidebar sidebar-fixed bg-white",
        attrs: { id: "sidebarMenu" }
      },
      [
        _c("div", { staticClass: "sidebar-header" }, [
          _c("h5", [_vm._v("Search")]),
          _vm._v(" "),
          _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
            _c("i", { attrs: { "data-feather": "x" } })
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input1" } }, [
      _vm._v("업체명 "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input2" } }, [
      _vm._v("업체코드 "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d1c95c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1c95c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Management/Company/DetailForm.vue
// module id = null
// module chunks = 